import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';

import { IFrame } from '@klp/iframe';

import { Main } from '@klp/layout';

import { ProjectDxboFrameAccess, PowerBiProjectDxboURL } from '../config';

import { kommentarerAccess } from '@klp/kommentarer/config';
import { KommentarerView } from '@klp/kommentarer';
import { contextSelectors } from '@klp/contextSelector';
import { useCurrentUser } from '@klp/auth';

const useStyles = makeStyles(() => ({
    iframe: {
        paddingTop: '50px',
    },
}));

export default function ProjectDxboView() {
    const classes = useStyles();
    const { t } = useTranslation();
    const { currentUser } = useCurrentUser();
    const { selectedContext } = useSelector(contextSelectors);

    const filteredProjectDxboHandler = () => {
        let filteredLink = PowerBiProjectDxboURL();

        if (selectedContext?.nummer !== undefined) {
            filteredLink += `&filter=dim_bygg_avdeling/bygg_avdeling_id%20eq%20%27${selectedContext.nummer}%27`;

            return filteredLink;
        }

        return filteredLink;
    };

    return (
        <>
            <Main>
                <Main.Breadcrumbs>
                    <Main.Crumb
                        id="projectdxbo"
                        label={t('breadcrumbs.project.report')}
                    />
                </Main.Breadcrumbs>
                {ProjectDxboFrameAccess(currentUser) && (
                    <IFrame
                        src={filteredProjectDxboHandler()}
                        fullScreen={true}
                        noSandbox={true}
                        className={classes.iframe}
                    />
                )}
            </Main>
            {kommentarerAccess() && <KommentarerView disableDragger={true} />}
        </>
    );
}
